// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"872":"18643dd6","881":"6db0040a"}[chunkId] + ".chunk.js";
};